<template>
  <router-view id="app" @login="loginDirect" @logout="logoutDirect"></router-view>
</template>

<script>
import utils from '@/common/utils'
import store from './vuex/store'
export default {

  data() {
    return {
      name: 'app'
    }
  },
  methods: {
    signin: function (callback) {
      let vm = this;
      store.commit('set_router', vm.$router);
      /*
      * Step 1
      * Check whether the user has access
      */

      let topath = vm.$router.currentRoute.path;
      let localUser = localStorage.getItem(topath);
      if (localUser) {

        return vm.$router.push({ path: vm.$router.currentRoute.path });
      } else {
        return vm.$router.push({ path: '/login' });
      }
    },
    loginDirect: function (newPath) {
      /*
      * Monitor login events
      * Will trigger the events in views/login.vue
      */
      this.signin(() => {
        this.$router.push({ path: newPath || '/' });
      });
    },
    logoutDirect: function () {
      /*
      * Monitor logout events
      * Will trigger the events in views/index.vue
      */
      //Clear local user information
      util.session('token', '');
      // logout 保留k0003 select选择值  Add xuyang 20230731
      var k0003_businessTypeSelectKey = localStorage.getItem('k0003_businessTypeSelectKey');
      console.log('logout-k0003_businessTypeSelectKey:' + k0003_businessTypeSelectKey);
      localStorage.clear();
      // logout 保留k0003 select选择值  Add xuyang 20230731
      localStorage.setItem('k0003_businessTypeSelectKey', k0003_businessTypeSelectKey);
      console.log(k0003_businessTypeSelectKey);
      // reload app
      window.location.href = process.env.BASE_URL || '/'
    },
    // 言語切替
    changeLang(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
    }
  },
  created: function () {
    /*
    * Start from here!
    */
    this.signin();
    // 言語切替
    this.changeLang('ja');
  }
}
</script>

<style>
@import './statics/css/site.css';
@import './statics/icon/iconfont.css';
* {
  -webkit-user-select: text;
}
@import '//at.alicdn.com/t/font_1511015_bjj69fauon6.css';
</style>



// WEBPACK FOOTER //
// src/App.vue